import React from "react";
import { Box, Typography } from "@mui/material";

const GradientBadge = ({
  icon,
  label,
  onClick,
  textColor = "#fff",
  sx = {},
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "relative",
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        px: 2,
        py: 1,
        borderRadius: "999px",
        backgroundColor: "rgba(255, 255, 255, 0.04)",
        boxShadow: "0 4px 36px rgba(0, 0, 0, 0.25)",
        border: "1px solid rgba(240, 210, 140, 0.20)",
        overflow: "hidden",
        cursor: "pointer",

        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          padding: "1px",
          borderRadius: "999px",
          background:
            "linear-gradient(90deg, rgba(240, 210, 140, 0.20) 0%, rgba(240, 210, 140, 0.00) 100%)",
          WebkitMask:
            "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
          WebkitMaskComposite: "xor",
          maskComposite: "exclude",
        },

        transition: "all 0.3s ease",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 0.08)",
          transform: "translateY(-1px)",
        },

        ...sx,
      }}
    >
      {icon}

      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 500,
          zIndex: 1,
          color: textColor,
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default GradientBadge;
